// Avoid having an export on the first line for istanbul

// We should try to keep this list as accurate and concise as possible.
// Add flags here as needed, but try to remember to remove them when they are no longer needed.

/**
 * All flags must have the actual flag string (often shishkabobed value).
 *
 * This is the set of flags which are a boolean value
 */
export const booleanFeatureFlagMap = {
  ai447CatalogAgenticChat: 'ai-447-catalog-agentic-chat',
  enableExplorerColumnLevelLineage: 'enable-explorer-column-level-lineage',
  meta3092ExplorerEnableDevEnvironment: 'meta-3092-explorer-enable-dev-environment',
  meta4182ExplorerContributions: 'meta-4182-explorer-contributions',
  meta4178PowerBiautoExposures: 'meta-4178-power-biauto-exposures',
  meta4521ExplorerRdpQuery: 'meta-4521-explorer-rdp-query',
  meta5507CatalogElasticsearch: 'meta-5507-catalog-elasticsearch',
  meta5835EnableCostEstimationFrontend: 'meta-5835-enable-cost-estimation-frontend',
  sideBySideSearchResults: 'side-by-side-search-results',
  orc2609ShowFusionToggle: 'ORC-2609-show-fusion-toggle',
  orc2664SaoBeta: 'orc-2664-sao-beta',
  meta5066DatabaseView: 'meta-5066-database-view',
  meta6609RedshiftQueryHistory: 'meta-6609-redshift-query-history',
  meta6610DatabricksQueryHistory: 'meta-6610-databricks-query-history',
  meta6937ErdView: 'meta-6937-erd-view',
} as const;

/**
 * All flags must have the actual flag string (often shishkabobed value)
 *
 * This is the set of flags which are a string value
 */
export const stringFeatureFlagMap = {} as const;

/**
 * All flags must have the actual flag string (often shishkabobed value)
 *
 * This is the set of flags which are a number value
 */
export const numberFeatureFlagMap = {} as const;

type BooleanFeatureFlag = keyof typeof booleanFeatureFlagMap;
type StringFeatureFlag = keyof typeof stringFeatureFlagMap;
type NumberFeatureFlag = keyof typeof numberFeatureFlagMap;

export const camelCaseFeatureFlagMap = {
  ...booleanFeatureFlagMap,
  ...stringFeatureFlagMap,
  ...numberFeatureFlagMap,
};

export const kebabCaseFeatureFlagSet = [
  ...(Object.values(booleanFeatureFlagMap) as Array<string>),
  ...(Object.values(stringFeatureFlagMap) as Array<string>),
  ...(Object.values(numberFeatureFlagMap) as Array<string>),
].reduce((acc, curr) => {
  return { ...acc, [curr]: undefined };
}, {});

export type FeatureFlagSet = Partial<
  Record<BooleanFeatureFlag, boolean> &
    Record<NumberFeatureFlag, number> &
    Record<StringFeatureFlag, string>
>;

/**
 * Feel free to commit changes here -- we will only use them in development.
 */
export const DEVELOPMENT_ONLY_FEATURE_FLAGS: FeatureFlagSet = {
  ai447CatalogAgenticChat: true,
  enableExplorerColumnLevelLineage: true,
  meta3092ExplorerEnableDevEnvironment: true,
  meta4182ExplorerContributions: true,
  meta4178PowerBiautoExposures: true,
  meta4521ExplorerRdpQuery: true,
  sideBySideSearchResults: false,
  meta5507CatalogElasticsearch: false,
  meta5835EnableCostEstimationFrontend: true,
  orc2609ShowFusionToggle: true,
  orc2664SaoBeta: true,
  meta5066DatabaseView: true,
  meta6609RedshiftQueryHistory: false,
  meta6610DatabricksQueryHistory: false,
  meta6937ErdView: false,
};
